import React from 'react'
import bamLogo from 'assets/Images/bam_logo.svg'
import { socialIcon } from 'pages/Events/Views/CreateEvent/utility'
import CustomModal from 'components/global/CustomModal'
import { EventEmailTemplateResp } from 'types/event/eventStep5'
import { capitalizeFirstLetter, convertToLocal } from 'helper/utility'
import Chip from 'components/global/Chip'
import { EventResp } from 'types/event/events'
import { creationEventStore } from 'state/event/eventCreationStore'

interface PreviewProps {
  openModal: boolean
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
  template: EventEmailTemplateResp
}

const Preview: React.FC<PreviewProps> = ({
  openModal,
  closeModal,
  template,
}) => {
  const { eventData }: { eventData: EventResp } = creationEventStore(store => ({
    eventData: store.eventData,
  }))

  const getAgeTagText = (minAge?: number, maxAge?: number) => {
    if (minAge === 0 && maxAge === 0) return 'All Ages'
    if (minAge && !maxAge) return `Ages ${minAge}+`
    if (!minAge && maxAge) return `Ages up to ${maxAge}`
    if (minAge && maxAge) return `Ages ${minAge}-${maxAge}`
    return 'All Ages'
  }
  const getTicketNames = () => {
    const ticketNames: string[] = []
    template.recipientsToSend.admissionTicketIds?.forEach(id => {
      const ticket = eventData.admissionTickets.find(
        ticket => ticket._id === id,
      )
      if (ticket) {
        ticketNames.push(ticket.name)
      }
    })

    template.recipientsToSend.additionalOptionIds?.forEach(id => {
      const ticket = eventData.additionalOptions.find(
        ticket => ticket._id === id,
      )
      if (ticket) {
        ticketNames.push(ticket.name)
      }
    })

    template.recipientsToSend.dropInTicketIds?.forEach(id => {
      if (eventData.dropInTicket && eventData.dropInTicket._id === id) {
        ticketNames.push(eventData.dropInTicket.name)
      }
    })

    return ticketNames
  }

  const tickets = getTicketNames()
  return (
    <>
      <CustomModal
        openModal={openModal}
        closeModal={closeModal}
        title="Preview Template"
        width={900}
        footer={false}
      >
        <div>
          <h3 className="text-16 w-500">
            {capitalizeFirstLetter(template.templateName)}
          </h3>
          {template.customTimeToSend ? (
            <p>{`Send at ${convertToLocal(template.description)}`}</p>
          ) : (
            <p>{`Send ${template.description}`}</p>
          )}
          <div className="flex gap-10px align-center flex-wrap">
            {template.recipientsToSend.gender ? (
              <Chip
                text={capitalizeFirstLetter(template.recipientsToSend.gender)}
              />
            ) : null}
            <Chip
              text={getAgeTagText(
                template.recipientsToSend.minAge,
                template.recipientsToSend.maxAge,
              )}
            />
            {tickets.map(ticket => {
              return <Chip text={capitalizeFirstLetter(ticket)} />
            })}
          </div>
        </div>
        <div className="bg-dark-gray mt-20px py-20px px-20px radius-12">
          <div className="mx-auto bg-white radius-12 shadow-box py-20px px-20px w-70p">
            <div className="flex w-full justify-center">
              <img src={bamLogo} alt="logo" width={130} height={90} />
            </div>
            <div
              className="mt-10px h-18rem scroller overflow-auto-y"
              dangerouslySetInnerHTML={{ __html: template.body }}
            ></div>

            <div
              className="flex flex-column align-center"
              style={{ marginTop: '60px' }}
            >
              <div className="flex gap-30px">
                {socialIcon.map((item, index) => (
                  <a href={item.url} target="_blank" key={index}>
                    <img src={item.icon} alt={item.url} />
                  </a>
                ))}
              </div>
              <p className="text-12 w-400 mt-20px">
                Copyright. Bamrec 2021. All rights rererved
              </p>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  )
}

export default Preview
